import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const NewServiceForm = (props) => {
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const handleSubmit = (event) => {
    event.preventDefault();
    const serviceName = event.target.name.value;
    const serviceDescription = event.target.description.value;
    const serviceTags = event.target.tags.value.split(" ");
    const servicePrice = event.target.price.value;    
    const serviceImage = "https://media.istockphoto.com/id/2060766764/vector/77.jpg?s=612x612&w=0&k=20&c=chKGOTPlfbntQjzdUTu26SiYYOoSmBwfD4wOXff8z_4=";

    const service = {
      name: serviceName,
      description: serviceDescription,
      tags: serviceTags,
      price: servicePrice,
      status: "disabled",
      image_url: serviceImage,
      provider_id: user.id
    };

    fetch(`${process.env.REACT_APP_SERVICE_API_URL}/services`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          'Api-Name': 'service-api',
        },
        body: JSON.stringify(service),
      })
        .then(response => response.json())
        .then(data => console.log(data))
        .catch(error => console.error(error));
    
    props.servicesList.push(service);
    // props.setServicesList(props.servicesList);
    console.log(props.servicesList);
    // navigate(props.navigate);
    props.setShowForm(false);
  };

  return (
    <div className="">
      <h1 className="text-left mtl-5 text-pri-dark text-sm md:text-xl mb-5"><strong>New Service Details</strong></h1>
      <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
        <div className="mt-1">
          <input
            id="name"
            name="name"
            type="text"
            autoComplete="name"
            maxLength={30}
            required
            className="block w-full border-0 py-1.5 text-pri-dark shadow-md shadow-dark-modal-shadow ring-1 ring-inset ring-pri-dark placeholder:text-gray-400 sm:text-sm sm:leading-6 border border-b-2 border-pri-dark rounded-xl active:translate-y-1 active:shadow-none"
            placeholder="Title *"
          />
          <p className="text-right text-pri-dark text-xs p-1"><strong>30</strong> characters max</p>
        </div>
        <div className="mt-1">
          <textarea
            id="description"
            name="description"
            autoComplete="description"
            required
            maxLength={200}
            className="block w-full border-0 py-1.5 text-pri-dark shadow-md shadow-dark-modal-shadow ring-1 ring-inset ring-pri-dark placeholder:text-gray-400 sm:text-sm sm:leading-6 border border-b-2 border-pri-dark rounded-xl active:translate-y-1 active:shadow-none"
            placeholder="Description *"
          />
          <p className="text-right text-pri-dark text-xs p-1"><strong>200</strong> characters max</p>
        </div>
        <div className="mt-1">
          <textarea
            id="tags"
            name="tags"
            type="text"
            autoComplete="tags"
            required
            className="block w-full border-0 py-1.5 text-pri-dark shadow-md shadow-dark-modal-shadow ring-1 ring-inset ring-pri-dark placeholder:text-gray-400 sm:text-sm sm:leading-6 border border-b-2 border-pri-dark rounded-xl active:translate-y-1 active:shadow-none"
            placeholder="Tag(s) (for multiple leave space) *"
          />
        </div>
        <div className="mt-2">
          <input
            id="price"
            name="price"
            type="text"
            autoComplete="price"
            required
            className="block w-full border-0 py-1.5 text-pri-dark shadow-md shadow-dark-modal-shadow ring-1 ring-inset ring-pri-dark placeholder:text-gray-400 sm:text-sm sm:leading-6 border border-b-2 border-pri-dark rounded-xl active:translate-y-1 active:shadow-none"
            placeholder="Price (£)*"
          />
        </div>
        {/* <div className="mt-2">
          <input
            id="imageUrl"
            name="imageUrl"
            type="text"
            autoComplete="imageUrl"
            required
            className="block w-full border-0 py-1.5 text-pri-dark shadow-md shadow-dark-modal-shadow ring-1 ring-inset ring-pri-dark placeholder:text-gray-400 sm:text-sm sm:leading-6 border border-b-2 border-pri-dark rounded-full active:translate-y-1 active:shadow-none"
            placeholder="Enter Image URL *"
          />
        </div> */}
        <button type="submit" className="p-2 bg-pri-dark text-sec-white rounded-full">
          Submit
        </button>
      </form>
    </div>
  );
}

export default NewServiceForm;